<div *ngIf="showPopup" class="cookie-consent-popup w-full flex flex-col sm:flex-row justify-between items-center gap-2 p-4">
  <div class="content-group flex items-center gap-4">
    <img src="assets/icons/info-svg.svg" alt="org logo" class="w-10 h-10" />
    <div class="cookie-consent-content">
      <p class="justified-text text-sm sm:text-base">
        Our website uses cookies to improve your experience, understand your
        preferences, and provide relevant content and advertising. Cookies help us
        remember your settings, enhance security, and improve our website's
        performance. You can choose to accept all cookies or adjust your
        preferences in the 'Settings' section. For more details, read our
        <a href="#" target="_blank" class="text-[#2368A2]">Privacy Policy</a>.
      </p>
    </div>
  </div>
  <div class="button-group grid grid-cols-2 sm:grid-cols-1 gap-2 mt-2 sm:mt-0">
    <button (click)="acceptCookies()" class="btn w-full">Accept</button>
    <button (click)="rejectCookies()" class="btn w-full">Reject</button>
  </div>
</div>
